import { render, staticRenderFns } from "./PreCreateRequest.vue?vue&type=template&id=c058a110&scoped=true"
import script from "./PreCreateRequest.vue?vue&type=script&lang=js"
export * from "./PreCreateRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c058a110",
  null
  
)

export default component.exports